import { IconProps } from "../../utils/global-types/global-types";

const InactiveUserIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M7.72 2.333a2.996 2.996 0 1 0 0 5.993 2.996 2.996 0 0 0 0-5.993M8.019 9.79c.168-.245.006-.618-.29-.619H6.93a4.46 4.46 0 0 0-4.459 4.46 1.82 1.82 0 0 0 1.82 1.819h3.48c.301 0 .463-.383.288-.627a4.37 4.37 0 0 1-.813-2.546c0-.924.285-1.78.772-2.488"
      ></path>
      <g clipPath="url(#clip0_9232_148095)">
        <path
          fill="currentColor"
          d="M11.637 8.776c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5"
        ></path>
        <path
          fill="#fff"
          d="M12.926 13.153a.291.291 0 1 1-.413.412l-.876-.876-.877.876a.29.29 0 1 1-.412-.412l.876-.877-.876-.876a.292.292 0 1 1 .412-.413l.877.877.876-.877a.291.291 0 1 1 .412.413l-.876.876z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_9232_148095">
          <path fill="#fff" d="M8.137 8.776h7v7h-7z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default InactiveUserIcon;
